import { makeStyles } from '@mui/styles'
const useStyles = makeStyles(() => ({
  boxIconMenu: { cursor: 'pointer' },
  hoverButton: {
    cursor: 'pointer',
    color: '#706E6F',
    '&:hover': {
      color: '#026873'
    }
  },
  hoverButtonRotate: {
    cursor: 'pointer',
    color: '#706E6F',
    transform: 'rotate(180deg)',
    '&:hover': {
      color: '#026873'
    }
  },
  stepperStyle: {
    width: 600,
    '@media all and (max-width: 600px)': {
      width: '100%'
    }
  },
  stepperStyleAddUser: {
    width: 500,
    '@media all and (max-width: 600px)': {
      width: '100%'
    }
  },
  stepperStyleSeeMore: {
    width: 800,
    '@media all and (max-width: 800px)': {
      width: '600px'
    },
    '@media all and (max-width: 600px)': {
      width: '400px'
    },
    '@media all and (max-width: 400px)': {
      width: '100%'
    }
  },
  typographyStyle: {
    paddingLeft: '1%',
    fontSize: 15,
    fontWeight: 700,
    textDecoration: 'none',
    '@media all and (max-width: 800px)': {
      fontSize: 14
    },
    '@media all and (max-width: 600px)': {
      fontSize: 13
    }
  },
  boxNav: {
    width: '100%',
    textDecoration: 'none'
  },
  boxButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start'
  },
  boxStyle: {
    width: 250,
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '1%',

    '@media all and (max-width: 600px)': {
      width: 200
    }
  }
}))

export default useStyles
